import domEventReg from '../on/_domeventregexp.js';
import checkObjectType from '../_helpers/checkobjecttype.js';
import matreshkaError from '../_helpers/matreshkaerror.js';
import forEach from '../_helpers/foreach.js';
import splitNames from '../on/_splitnames.js';
import defs from '../_core/defs.js';
import triggerOne from './_triggerone.js';
import triggerDomEvent from './_triggerdomevent.js';
export default function trigger() {
  var object;
  var givenNames;
  var triggerArgs;
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  if (typeof this === 'object' && this.isMatreshka) {
    // when context is Matreshka instance, use this as an object and shift other args
    givenNames = args[0];
    triggerArgs = args.slice(1);
    object = this;
  } else {
    object = args[0];
    givenNames = args[1];
    triggerArgs = args.slice(2);
    // throw error when object type is wrong
    checkObjectType(object, 'trigger');
  }
  var names;
  // allow to use strings only as event name
  if (typeof givenNames === 'string') {
    names = splitNames(givenNames);
  } else {
    throw matreshkaError('trigger:names_type', {
      names: givenNames
    });
  }
  var def = defs.get(object);
  // if no definition do nothing
  if (!def) {
    return object;
  }
  forEach(names, function (name) {
    var domEvtExecResult = domEventReg.exec(name);
    if (domEvtExecResult) {
      // if EVT::KEY(SELECTOR) ia passed as event name then trigger DOM event
      var eventName = domEvtExecResult[1],
        _domEvtExecResult$ = domEvtExecResult[2],
        key = _domEvtExecResult$ === void 0 ? 'sandbox' : _domEvtExecResult$,
        selector = domEvtExecResult[3];
      triggerDomEvent(def, key, eventName, selector, triggerArgs);
    } else {
      // trigger ordinary event
      triggerOne(object, name, triggerArgs);
    }
  });
  return object;
}